import React, { Component } from 'react';
import './index.css'

export default class RelationshipDetail extends Component {
  constructor(props) {
    super(props);
  }

  closeAlert = () =>{
    this.props.newProps && this.props.newProps.props &&  this.props.newProps.props.onRemoveRoot && this.props.newProps.props.onRemoveRoot();
  }

  render() {
    const { data } = this.props;
    return <div className="RelationshipDetail">
      <div className="detail-header">
        <div className="header-title">{React.language('relationship.detail')}</div>
        <div className="header-close" onClick={this.closeAlert}><i className="icon-close-large"></i></div>
      </div>
      <div className="detail-body">
        {
          data.map(v=>{
            const byNode = v.byFormInfo;
            const node = v.formInfo;
            let byNodeName = "";
            let nodeName = "";
            if(byNode.formType === "extend"){
              byNodeName = byNode.name;
            }else{
              byNodeName = byNode.formName;
            }
            if(node.formType === "extend"){
              nodeName = node.name;
            }else{
              nodeName = node.formName;
            }
            return <div className={"detail-item"}>
              <div className="item-title">{nodeName + "→" + byNodeName}</div>
              <div className="item-content">
                <div className="cont-line typeInfo">
                  <div className="line-title">{React.language('typeInfo.label')}：</div>
                  <div className="line-value">{<span>{v.typeInfo.name}</span>}</div>
                </div>
                <div className="cont-line modeInfo">
                  <div className="line-title">{React.language('modeInfo.label')}：</div>
                  <div className="line-value">{<span>{v.modeInfo.name}</span>}</div>
                </div>
                <div className="cont-line detailsInfo">
                  <div className="line-title">{React.language('typeInfo.label')}：</div>
                  <div className="line-value">
                    {
                      <span title={v.detailsInfo.tipTextAll}>
                        {v.detailsInfo.tipText}
                        {!!v.detailsInfo.url && <a href={v.detailsInfo.url} target="_blank" className={`link-tip`}> {React.language('detail')}</a>}
                    </span>
                    }
                  </div>
                </div>
              </div>
            </div>
          })
        }
      </div>
    </div>
  }
}